import axios from 'axios';
import * as api from '@pointOfSale/api';
import { getNextPageProducts } from '@pointOfSale/processes';
import { Product } from '../models';
import * as MutationTypes from '../mutationTypes';

export const masterProductListRequest = async ({
  commit,
  getters: { masterProductList }
}, pointOfSaleGuid) => {
  try {
    if (masterProductList.length === 0) {
      // https://stackoverflow.com/questions/30233302/promise-is-it-possible-to-force-cancel-a-promise
      const { CancelToken } = axios;
      const source = CancelToken.source();
      const { token } = source;
      commit(MutationTypes.MASTER_PRODUCT_LIST_TOKEN, source);
      const response = await api.productListRequest(pointOfSaleGuid, token, {});
      if (response) {
        const { count, results } = response.data;
        const productList = Product.toInstanceList(results);
        commit(MutationTypes.MASTER_PRODUCT_LIST_UPDATE, { productList, count, pointOfSaleGuid });
        if (response.data.next) {
          await getNextPageProducts(commit, response.data.next, token, pointOfSaleGuid);
        }
      }
      commit(MutationTypes.MASTER_PRODUCT_LIST_SUCCESS);
    }
  } catch (err) {
    commit(MutationTypes.MASTER_PRODUCT_LIST_ERROR);
    throw err;
  }
};

export const updateMasterProductRequest = async ({ commit }, { productToUpdate, reduced = false }) => {
  const formData = reduced ? productToUpdate.getReducedFormData() : productToUpdate.getFormData();
  await api.updateMasterProductRequest(formData);
  commit(MutationTypes.MASTER_PRODUCT_UPDATE, productToUpdate);
};

export const updateMasterProductSaleFormats = async ({ commit }, productToUpdate) => {
  const res = await api.updateMasterProductSaleFormats(productToUpdate);
  if (res.status_code === 201) {
    commit(MutationTypes.MASTER_PRODUCT_SALE_FORMAT_SUCCESS, productToUpdate);
  }
};
